import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import cs from 'classnames'
import { Typography } from '@material-ui/core'

const isCenter = pos => pos === 'center'

const useStyles = makeStyles(theme => ({
    wrapper: {
        marginBottom: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: ({ position }) =>
            isCenter(position) ? 'center' : 'space-between'
    },
    title: {
        color: theme.primary,
        marginRight: 16,
        fontSize: 30,
        letterSpacing: '-1.6px',
        fontWeight: 'bold',
        fontFamily: theme.fontFamily,
        flexGrow: ({ position }) => (isCenter(position) ? 0 : 1)
        /* lineHeight: "30px" */
    }
}))

export default function PageTitle({
    title,
    children,
    className,
    beforeContent,
    position,
    wrapTitle = false
}) {
    const classes = useStyles({ position })

    return (
        <div className={cs(classes.wrapper, className)}>
            {beforeContent && <React.Fragment>{beforeContent}</React.Fragment>}
            <Typography
                className={classes.title}
                noWrap={wrapTitle ? false : true}
            >
                {title}
            </Typography>
            {children}
        </div>
    )
}
